module.exports = new __parcel__URL__("battlepass_claimed_button.a56d876c.png").toString();